import { getLanguageCode } from 'toolkit/utils';
import DE from './DE';
import EN from './EN';
import TR from './TR';
export default function PrivacyPolicy() {
  if (getLanguageCode() == 'tr-TR') {
    return (
      <>
        <TR />
      </>
    );
  } else if (getLanguageCode() == 'de-DE') {
    return (
      <>
        <DE />
      </>
    );
  } else
    return (
      <>
        <EN />
      </>
    );
}
